<div class="col-md-12 flex mt-4">

<div class="col">
        
    <div style="width: 100% " class="flex"><div class="cal"></div> &nbsp; <span class="totalCal font-weight-bold">Total Calories :</span><span class="nutriVal ml-2"> {{Math.round(foodInfo.totalCalories)}} C</span></div>
</div>

<div class="col">
   
    <div style="width: 100%" class="flex"><div class="protien"></div> &nbsp;<span class="totalCal font-weight-bold">Total Protein :</span><span class="nutriVal ml-2"> {{foodInfo.totalProteins.toFixed(1)}} g</span></div>
</div>
<div class="col">
    
    <div style="width: 100%" class="flex"><div class="carb"></div> &nbsp;  <span class="totalCal font-weight-bold">Total Carbs :</span><span class="nutriVal ml-2"> {{foodInfo.totalCarbs.toFixed(1)}} g</span></div>
</div>
<div class="col">

    <div style="width: 100%" class="flex"> <div class="fat"></div> &nbsp;  <span class="totalCal font-weight-bold">Total Fats :</span><span class="nutriVal ml-2"> {{foodInfo.totalFats.toFixed(1)}} g</span></div>
</div>
<div class="col">

    <div style="width: 100%" class="flex"> <div class="fiber"></div> &nbsp;  <span class="totalCal font-weight-bold">Total Fiber :</span><span class="nutriVal ml-2"> {{foodInfo.totalFiber ? foodInfo.totalFiber.toFixed(1) : '0.0'}} g</span></div>
</div>
</div>